import { queryKey } from '@vindr/services/constants/queryClientKey';
import { getUserInfo } from '@vindr/services/apis/user.api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const useUserInfo = (
  options?: UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>>
) => {
  return useQuery([queryKey.userInfo], getUserInfo, {
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    ...options,
  });
};

export default useUserInfo;
